import React from "react";
import Modal from '../Modal'
import LoaderButton from "../LoaderButton";
import { checkTranslation, translate } from "../../utils/useful";
import FormViewer from "../FormViewer";
import SwitchInput from "../inputs/SwitchInput";
import TopicView from "../views/messenger/sideBar/TopicView";
import StagesManager from "../StagesManager";
import ImportModalFirst from "./ImportModalFirst";
import ImportModalSecond from "./ImportModalSecond";
import ImportModalThird from "./ImportModalThird";
import ImportModalForth from "./ImportModalForth";
import SwitchStyle1 from "../useful/SwitchButton";
import Collapsible from "react-collapsible";
import HttpServices from "../../utils/Http.services";
import { siteConfig } from "../../variables/config";
import { saveAs } from 'file-saver';

class ExportModal extends React.Component {
    state = {
        // Storages: [
        //     { icon: "/assets/icons/uploadmodal/paperclip.svg", title: "My Device" },
        //     { icon: "/assets/icons/uploadmodal/link.svg", title: "Link (URL)" },
        //     { icon: "/assets/icons/uploadmodal/googledrive.svg", title: "Google Drive" },
        //     { icon: "/assets/icons/uploadmodal/onedrive.svg", title: "One Drive" },
        //     { icon: "/assets/icons/uploadmodal/dropbox.svg", title: "DropBox" },
        // ],

        headers: [
            { key: 'Format', type: 'SelectInput', col: '12', information: { type: "local", defaultValue: 'xls', items: [{ title: '{{lang}}Excel', value: 'xls' }, { title: '{{lang}}CSV', value: 'csv' }], label: '{{lang}}Export Format', placeholder: 'Format', required: true } },
            // { key: 'layout', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Layout', placeholder: '{{lang}}Landscape', required: true } },
            // { key: 'fieldsizing', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Feild sizing', placeholder: '{{lang}}Actual size', required: true } },
            // { key: 'fontsize', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Font size', placeholder: '{{lang}}Normal', required: true } },
        ],

        options: [
            { title: "{{lang}}Column name 1" },
            { title: "{{lang}}Column name 2" },
            { title: "{{lang}}Column name 3" },
        ],
        customized: true,
        customizeFields: [],
    }

    componentDidMount() {

        if (Array.isArray(this.props.headers)) {
            let customizeFields = JSON.parse(JSON.stringify(this.props.headers))

            customizeFields.forEach(el => {
                if (el.type != 'ImageInput' && el.type != 'FileInput') {
                    el.customized = true
                }
            });
            this.setState({ customizeFields })
        }
    }

    onChangeCustomizeFields = (id, isOn) => {
        let { customized, customizeFields } = this.state
        if (id == 'customize') {
            customized = isOn
            this.setState({ customized })
        }
        else {
            customizeFields[id].customized = isOn
            this.setState({ customizeFields }, () => {
            })
        }
    }
    fetchExport = () => {

this.setState({isLoading:true})
        let body = {};

        body.limit = this.props.limit ?? 20; body.skip = this.props.currentPage; body.filter = this.props.filter ?? {}
        // body.page = page.key

        if (this.props.filter2) body.filter2 = this.props.filter2

        if (this.props.postBody) body.filter = { ...body.filter, ...this.props.page.postBody }

        if (this.props.populate) body.populate = this.props.page.populate

        if (this.props.sort) body.sort = this.props.page.sort


        body.filter.frame = this.props.frame._id
        body.headers = this.props.headers
        if (this.state.customized) {
            body.headers = this.state.customizeFields.filter(el => el.customized == true)
        }
        // console.log(body);
        // return
        body.model = 'record'
        body.frame = this.props.frame
        let form = this.form.getForm()
        if (form) {

            body.format = form.Format
        } else {
            body.format = 'xls'

        }


        HttpServices.request('exportExcel', body, (fetchResult, fetchError) => {

            if (fetchError) {

                return
            }

            saveAs(siteConfig.assetsDomain + 'tempfiles/' + fetchResult.info)
this.setState({isLoading:false})
            this.modal.hideModal()
        })
    }


    render() {
        
        let options = this.state.options
        return (

            <Modal maxWidth={350} height={"100%"} ref={el => this.modal = el} marginBottom={"5%"}>
                <div className="w-100 h-100 br-10" style={{ backgroundColor: "white", overflow: 'hidden' }} >
                    <div className='p-3 position-sticky top-0' style={{ background: 'linear-gradient(90deg, #5856D6, #7D7AFF)', zIndex: 2, height: '50px' }}>
                        <p className="font-size-18 weight-500 white">{translate('Export Setting')}</p>
                    </div>
                    <div className="w-100 flexcb flex-column" style={{ overflow: 'scroll', height: 'calc(100% - 50px)' }}>
                        <div className="w-100">
                            <div className="mt-3 px-2">
                                <FormViewer ref={el => this.form = el} headers={this.state.headers} theme={"modern"} inputClass={"modern-input4"} />
                            </div>
                            <div className="px-4">
                                <div className="flexcb w-100 py-2">
                                    <p className="font-size-16 weight-400">{translate('Custom fields')}</p>
                                    <div className="flexcc">
                                        <SwitchStyle1 id={'customize'} onChange={() => { this.onChangeCustomizeFields('customize', !this.state.customized) }} isOn={this.state.customized} color={'#4E4CCC'} />
                                    </div>
                                </div>
                                <Collapsible open={this.state.customized}>
                                    <div className="w-100 pt-2 mt-2" style={{ borderTop: '1px solid #eee' }}>
                                        {Array.isArray(this.state.customizeFields) && this.state.customizeFields?.map((prop, index) => {
                                            if (prop.showMain != false) {
                                                return (
                                                    <div className="flexcb w-100 py-2" key={prop.id}>
                                                        <p className="font-size-14 weight-300">{checkTranslation(prop.information?.label)}</p>
                                                        <div className="flexcc">
                                                            <SwitchStyle1 id={prop.id} isOn={prop.customized} onChange={() => this.onChangeCustomizeFields(index, !prop.customized)} color={'#4E4CCC'} />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })}
                                        {/* {this.state.options.map((prop, index) => {
                                return (
                                    <div className="flexcb w-100 py-2" key={index}>
                                        <p className="font-size-14 weight-300">{checkTranslation(prop.title)}</p>
                                        <div className="flexcc">
                                            <SwitchStyle1 id={index} color={'#4E4CCC'} />
                                        </div>
                                    </div>
                                )
                            })} */}
                                    </div>
                                </Collapsible>
                            </div>
                        </div>
                        {/* <div className="mx-4 mt-4 br-15" style={{ backgroundColor: "#f6f6f6" }}>
                        <p className="p-3 font-size-12 weight-300">Create Completely custom print layouts whit the<span className="text-link"> page builder </span>feture.</p>
                    </div> */}
                        <div className="p-4 w-100 d-flex" style={{ justifyContent: "flex-end" }}>
                            <button className="gray-btn px-3 py-2 br-5" onClick={() => { this.modal.hideModal() }}>
                                <p className="font-size-14">{translate('Cancel')}</p>
                            </button>
                                {/* <button onClick={() => this.fetchExport()} className="px-4 py-2 br-5 mld-4 purple-btn">
                                    <p className="white font-size-14">{translate('Export')}</p>
                                </button> */}
                            <LoaderButton
                                onClick={() => this.fetchExport()}
                                isLoading={this.state.isLoading}
                                text={translate("Export")}
                                // icon={'/assets/icons/imports/export.svg'}
                                backgroundImage='linear-gradient(90deg, #5856D6, #7D7AFF)'
                                className={'px-4 py-2 br-5 mld-4 purple-btn'}

                            />
                        </div>
                    </div>
                </div>
            </Modal>
        );

    }
}


export default ExportModal;
